import { apiClientes } from "../config/api";
import { DescontoFarmacia } from "../interfaces/entities/DescontoFarmacia";

export const getDescontoEmFarmacias = async (): Promise<DescontoFarmacia[] | null> => {
    try {
        const response = await apiClientes.get('Config/GetDescontoEmFarmacias');
        return response.data;
    } catch (error: any) {
        const errorData = error?.response?.data;
        return errorData
    }
}